import { Box, TextField, SvgIcon, alpha } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { TYPE } from '@/theme/typography';
import { SOCIAL_BRAND_COLORS } from '@/theme/colorTokens';

// ── Brand colors ──
const BRANDS = {
  linkedin: { color: SOCIAL_BRAND_COLORS.linkedin, label: 'LinkedIn', placeholder: 'https://linkedin.com/company/...' },
  twitter: { color: SOCIAL_BRAND_COLORS.twitter, label: 'X (Twitter)', placeholder: 'https://x.com/...' },
  facebook: { color: SOCIAL_BRAND_COLORS.facebook, label: 'Facebook', placeholder: 'https://facebook.com/...' },
  instagram: { color: SOCIAL_BRAND_COLORS.instagram, label: 'Instagram', placeholder: 'https://instagram.com/...' },
  youtube: { color: SOCIAL_BRAND_COLORS.youtube, label: 'YouTube', placeholder: 'https://youtube.com/...' },
} as const;

// ── SVG logo paths (official simplified marks) ──
function LinkedInIcon() {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
      />
    </SvgIcon>
  );
}

function XTwitterIcon() {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
      />
    </SvgIcon>
  );
}

function FacebookIcon() {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
      />
    </SvgIcon>
  );
}

function InstagramIcon() {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678a6.162 6.162 0 100 12.324 6.162 6.162 0 100-12.324zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405a1.441 1.441 0 11-2.88 0 1.441 1.441 0 012.88 0z"
      />
    </SvgIcon>
  );
}

function YouTubeIcon() {
  return (
    <SvgIcon viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
      />
    </SvgIcon>
  );
}

const ICONS: Record<string, () => JSX.Element> = {
  linkedin: LinkedInIcon,
  twitter: XTwitterIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  youtube: YouTubeIcon,
};

interface SocialMediaFieldsProps {
  values: {
    linkedin_url: string;
    twitter_url: string;
    facebook_url: string;
    instagram_url: string;
    youtube_url: string;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FIELD_MAP: { key: string; name: string }[] = [
  { key: 'linkedin', name: 'linkedin_url' },
  { key: 'twitter', name: 'twitter_url' },
  { key: 'facebook', name: 'facebook_url' },
  { key: 'instagram', name: 'instagram_url' },
  { key: 'youtube', name: 'youtube_url' },
];

export default function SocialMediaFields({ values, onChange }: SocialMediaFieldsProps) {
  return (
    <Grid container spacing={2}>
      {FIELD_MAP.map(({ key, name }) => {
        const brand = BRANDS[key as keyof typeof BRANDS];
        const Icon = ICONS[key];
        return (
          <Grid key={key} size={{ xs: 12, sm: 6 }}>
            <Box
              className="social-field"
              sx={{
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                px: 1.5,
                py: 0.75,
                transition: 'all 0.2s ease',
                '&:hover, &:focus-within': {
                  borderColor: brand.color,
                  boxShadow: `0 0 0 1px ${alpha(brand.color, 0.25)}`,
                },
                '&:hover .social-icon, &:focus-within .social-icon': {
                  bgcolor: brand.color,
                  color: 'common.white',
                },
              }}
            >
              {/* Branded icon pill */}
              <Box
                className="social-icon"
                sx={{
                  width: 38,
                  height: 38,
                  minWidth: 38,
                  borderRadius: 1.5,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: alpha(brand.color, 0.1),
                  color: brand.color,
                  transition: 'all 0.2s ease',
                  '& .MuiSvgIcon-root': { fontSize: 20 },
                }}
              >
                <Icon />
              </Box>

              {/* URL input */}
              <TextField
                fullWidth
                name={name}
                value={(values as Record<string, string>)[name] || ''}
                onChange={onChange}
                placeholder={brand.placeholder}
                variant="standard"
                slotProps={{
                  input: {
                    disableUnderline: true,
                    sx: { fontSize: TYPE.base, py: 0.5 },
                  },
                }}
              />
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
}
